import { styled, Tabs } from "@mui/material";

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  marginBottom: "32px",
  "& .MuiTab-root": {
    textTransform: "none",
    fontSize: "16px",
    fontWeight: 500,
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.primary.main,
    },
  },
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.primary.main,
  },
}));
